import type { FaireProductEntity } from "../../entity_types/product";

export const p_u2mxceszzh: FaireProductEntity = {
  token: "p_u2mxceszzh",
  type: "product",
  name: "Tox Queen Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/cc8b6f37c8e06f172c5e359f4bcbd4011acce4575a61e5cfd9b16d71d5a9bbac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/35ea7baef062359b7d35f5de6aef0214d375f48e5c72726f158c83ed85abdc05.jpeg",
    "https://cdn.faire.com/fastly/4c5da7992970d3a651300e73b154f7e1a036d1020f739a175d3848355c67cd8d.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/9a5cc3a7d2a3cc79289495f06f72acdaf7ee643429fce1e0dfb8b672a9701414.jpeg",
    "https://cdn.faire.com/fastly/0a68813f161ac3c440382c10e2452da2185b95f5f69dcc3138dda57301d6c3c9.jpeg"
  ],
  priceDollars: 6.75,
  description: "Socks for when you've got the kind of polish that looks effortless but definitely isn't accidental.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:31.804Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
